import styled from 'styled-components';

export const ArticleSearchResultsWrapper = styled.div`
  margin: 0 5px;
`;
